import React, { FC, useState } from 'react';

import Tab from '../Tab';
import GraphQLQueryText from '../GraphQLQueryText';
import GraphQLQueryVariables from '../GraphQLQueryVariables';
import GraphQLQueryData from '../GraphQLQueryData';
import GraphQLQuerySql from '../GraphQLQuerySql';

import { GraphQLQuery } from '../../types';

import styles from './GraphQLQueryViewer.module.css';

type Props = {
  query: GraphQLQuery;
  onClose?: () => void;
};

const GraphQLQueryViewer: FC<Props> = ({ query, onClose }) => {
  const [tab, setTab] = useState(0);

  return (
    <div className={styles.root}>
      <div className={styles.toolbar}>
        <button onClick={onClose} className={styles.closeBtn}>
          x
        </button>

        <div className={styles.tabs}>
          <Tab selected={tab === 0} onClick={() => setTab(0)}>
            Query
          </Tab>

          <Tab selected={tab === 1} onClick={() => setTab(1)}>
            Variables
          </Tab>

          <Tab selected={tab === 2} onClick={() => setTab(2)}>
            Data
          </Tab>

          <Tab selected={tab === 3} onClick={() => setTab(3)}>
            SQL
          </Tab>
        </div>
      </div>

      <div className={styles.content}>
        {tab === 0 && <GraphQLQueryText query={query} />}
        {tab === 1 && <GraphQLQueryVariables query={query} />}
        {tab === 2 && <GraphQLQueryData query={query} />}
        {tab === 3 && <GraphQLQuerySql query={query} />}
      </div>
    </div>
  );
};

export default GraphQLQueryViewer;
